var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-server-plus","label":"Deploy now","text":""},on:{"click":function($event){return _vm.exec(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }